module.exports = __webpack_public_path__ + "assets/img/ru-0fa5e4c5.png";